(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp-customer-reviews')) {
    customElements.define('dp-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dp-customer-reviews__track');
        this.cards = Array.from(this.querySelectorAll('.dp-customer-reviews__card'));
        this.controls = this.querySelector('.dp-customer-reviews__controls');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.counter = this.querySelector('[data-current]');
        if (!this.track || !this.cards.length) return;
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        };
        this.onClick = event => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          this.move(Number(button.dataset.direction));
        };
        this.onKey = event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
          } else {
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        };
        this.onSelect = event => {
          const card = event.target.closest('.dp-customer-reviews__card');
          if (card && this.contains(card)) this.goTo(this.cards.indexOf(card), 'instant');
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKey);
        this.controls.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onSelect);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKey);
        this.controls?.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      currentIndex() {
        const start = this.track.getBoundingClientRect().left;
        return this.cards.reduce((nearest, card, index) =>
          Math.abs(card.getBoundingClientRect().left - start) < Math.abs(this.cards[nearest].getBoundingClientRect().left - start) ? index : nearest, 0);
      }
      updateControls() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const index = this.currentIndex();
        this.controls.hidden = maxScroll < 2;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
        const visible = this.cards.filter(card => {
          const bounds = card.getBoundingClientRect();
          const trackBounds = this.track.getBoundingClientRect();
          return bounds.left >= trackBounds.left - 3 && bounds.right <= trackBounds.right + 3;
        });
        const end = visible.length ? this.cards.indexOf(visible[visible.length - 1]) + 1 : index + 1;
        this.counter.textContent = end > index + 1 ? `${index + 1}–${end}` : `${index + 1}`;
      }
      move(direction) {
        this.goTo(Math.max(0, Math.min(this.cards.length - 1, this.currentIndex() + direction)));
      }
      goTo(index, behavior) {
        if (!this.cards[index]) return;
        const offset = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
